module.exports = __webpack_public_path__ + "img/Sanofi.427cc6d2.jpg";